import React, { useEffect, useState } from 'react';
import {IProps, IState} from './types';
import ComboBox from '@components/ComboBox';
import * as S from './styles';
import C from '@assets/themes/colors';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@state/actions';
import selectors from '@state/selectors';
import CustomTag from '@components/CustomTag';
import Chips from '@components/Chips';
import { IDSConfig, IBrandDefinition } from '@state/dsconfig/types';

const Tags:React.FC<IProps> = (props, state:IState) => {

  const dispatch = useDispatch();
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const fromEditTemplate = props.fromEditTemplate && props.fromEditTemplate === true;

  const [designTypes, setDesignTypes] = useState(state.designTypes);
  const [platforms, setPlatforms] = useState(state.formats);
  const [formats, setFormats] = useState(state.platforms);
  const [currentDesignTypeIndex, setCurrentDesignTypeIndex] = useState(0);
  const [currentPlatformIndex, setCurrentPlatformIndex] = useState(0);

  useEffect(() => {
    if (dsConfig && dsConfig.designTypes) {
      var newDesignTypes: string[] = [];
      for (var i = 0; i < dsConfig.designTypes.length; i++) {
        const designTypeName = dsConfig.designTypes[i].name;
        newDesignTypes.push(designTypeName);
      }
      setDesignTypes([...newDesignTypes]);
    }
  }, [dsConfig])

  useEffect(() => {
    const currentTags = props.files[props.currentIndex]?.tags;
    if (currentTags) { 
      if (currentTags.designType && currentTags.designType !== "" && designTypes && designTypes.length > 0) {
        const designTypeIndex = designTypes.findIndex((designType) => designType === currentTags.designType);
        if (designTypeIndex >= 0) {
          const currentPlatforms = handlePlatforms(designTypeIndex);
          if (currentTags.platform && currentTags.platform !== "" && currentPlatforms && currentPlatforms.length > 0) {
            const platformIndex = currentPlatforms.findIndex((platform) => platform === currentTags.platform);
            if (platformIndex >= 0) {
              handleFormats(platformIndex, designTypeIndex);
            }
          } else {
            setFormats([]);
          }
        }
      } else {
        setPlatforms([]);
        setFormats([]);
      }
    } else {
      setPlatforms([]);
      setFormats([]);
    }
  }, [props.currentIndex, designTypes])

  const handlePlatforms = (index: number) => {
    var newPlatforms: string[] = [];
    const selectedPlatforms = dsConfig.designTypes[index].platforms;
    for (var i = 0; i < selectedPlatforms.length; i++) {
      const designTypeName = selectedPlatforms[i].name;
      newPlatforms.push(designTypeName);
    }
    setCurrentDesignTypeIndex(index);
    setPlatforms([...newPlatforms]);
    return [...newPlatforms];
  }

  const handleFormats = (index: number, dtIndex: number | undefined) => {
    var newPlatforms: string[] = [];
    var designTypeIndex = 0;
    if (dtIndex !== undefined) designTypeIndex = dtIndex
    else designTypeIndex = currentDesignTypeIndex;
    const selectedFormats = dsConfig.designTypes[designTypeIndex].platforms[index].formats;
    for (var i = 0; i < selectedFormats.length; i++) {
      const formatName = `${selectedFormats[i].name} - ${selectedFormats[i].width}px x ${selectedFormats[i].height}px`;
      newPlatforms.push(formatName);
    }
    setCurrentPlatformIndex(index);
    setFormats([...newPlatforms]);
  }

  const formatsToString = (option: string) => {
    var newFormats :string[] = [];
    if (props.files[props.currentIndex]?.tags?.formats && props.files[props.currentIndex]?.tags?.formats.length > 0){
      props.files[props.currentIndex].tags.formats.map((format: any, index: number) => {
        if (option === "full-format")
        newFormats.push(`${format.name} - ${format.width}px x ${format.height}px`);
        else
        newFormats.push(`${format.name}`);
      })
    }
    return newFormats;
  }

  const handleSelectFormat = (value: any) => {
    var newFormats: any[] = props.files[props.currentIndex]?.tags?.formats ? props.files[props.currentIndex].tags.formats : [];
    const newFortmatIndex = newFormats.findIndex((format: any) => (format.name === value.name));
    if (newFortmatIndex >= 0) {
      newFormats = [
        ...newFormats.slice(0, newFortmatIndex),
        ...newFormats.slice(newFortmatIndex + 1)
      ];
    } else {
      newFormats.push(value);
    }
    return newFormats;
  }

  const handleRemoveFormat = (index: number) => {
    var file = props.files[props.currentIndex];
    file = {...file, tags: {
      ...file.tags, formats: [...file.tags.formats.slice(0, index), ...file.tags.formats.slice(index + 1)]
    }}
    props.setFiles([
      ...props.files.slice(0, props.currentIndex),
      {...file},
      ...props.files.slice(props.currentIndex + 1)
    ])
  }

  const handleSelectOption = (id:string, value:string) => {
    var file = props.files[props.currentIndex];
    if(file)
    if (id === "design-type") {
      const designTypeIndex = dsConfig.designTypes.findIndex((designType) => designType.name === value);
      if (designTypeIndex >= 0) {
        handlePlatforms(designTypeIndex);
        setFormats([]);
        file = {...file, tags: {
          ...file.tags, designType: dsConfig.designTypes[designTypeIndex].name, platform: undefined, formats: undefined
        }}
      }
    } else if (id === "platform") {
      const platformIndex = dsConfig.designTypes[currentDesignTypeIndex].platforms.findIndex((platform) => platform.name === value);
      if (platformIndex >= 0) {
        handleFormats(platformIndex, undefined);
        file = {...file, tags: {
          ...file.tags, platform: dsConfig.designTypes[currentDesignTypeIndex].platforms[platformIndex].name, formats: undefined
        }}
      }
    } else if (id === "formats") {
      let newValue = value.split('-')[0];
      let formatIndex = -1;
      if (newValue.length > 0) {
        newValue = newValue.substr(0, newValue.length - 1);
        formatIndex = dsConfig.designTypes[currentDesignTypeIndex].platforms[currentPlatformIndex].formats.findIndex((format) => format.name === newValue);
      }
      if (formatIndex >= 0) {
        file = {...file, tags: {
          ...file.tags, formats: handleSelectFormat(dsConfig.designTypes[currentDesignTypeIndex].platforms[currentPlatformIndex].formats[formatIndex])
        }}
      }
    } else if (id === "oem") {
      file = {...file, tags: {
        ...file.tags, oem: value
      }}
    } else if (id === "offer-type") {
      file = {...file, tags: {
        ...file.tags, offerType: value
      }}
    } else if (id === "holiday") {
      file = {...file, tags: {
        ...file.tags, holiday: value
      }}
    }
    props.setFiles([
      ...props.files.slice(0, props.currentIndex),
      {...file},
      ...props.files.slice(props.currentIndex + 1)
    ])
  }

  const handleAddCustomTag = (value: string) => {
    var file = props.files[props.currentIndex];
    if (props.files[props.currentIndex]?.tags?.customTags === undefined) {
      file = {...file, tags: {
        ...file.tags, customTags: []
      }}
    }
    file = {...file, tags: {
      ...file.tags, customTags: [...file.tags.customTags, value]
    }}
    props.setFiles([
      ...props.files.slice(0, props.currentIndex),
      {...file},
      ...props.files.slice(props.currentIndex + 1)
    ])
  }

  const handleRemoveCustomTag = (index: number) => {
    var file = props.files[props.currentIndex];
    file = {...file, tags: {
      ...file.tags, customTags: [...file.tags.customTags.slice(0, index), ...file.tags.customTags.slice(index + 1)]
    }}
    props.setFiles([
      ...props.files.slice(0, props.currentIndex),
      {...file},
      ...props.files.slice(props.currentIndex + 1)
    ])
  }

  const offerTypeAndHoliday = () => {
    return (
      <>
        <ComboBox 
          id="offer-type"
          placeholder="Offer Type"
          title="Offer Type"
          options={dsConfig.offerTypes?.sort()}
          required={false}
          disabled={false}
          position={fromEditTemplate ? "bottom" : "top"}
          chooseOption={handleSelectOption}
          value={props.files[props.currentIndex]?.tags?.offerType ? props.files[props.currentIndex]?.tags?.offerType : ""}
        />
        <ComboBox 
          id="holiday"
          placeholder="Holiday"
          title="Holiday"
          options={dsConfig.holidays?.sort()}
          required={false}
          disabled={false}
          position={fromEditTemplate ? "bottom" : "top"}
          chooseOption={handleSelectOption}
          value={props.files[props.currentIndex]?.tags?.holiday ? props.files[props.currentIndex]?.tags?.holiday : ""}
        />
      </>
    );
  }

  return (
    <S.Root 
      style={{margin: props.fromEditTemplate && props.fromEditTemplate === true ? '40px 60px 40px 60px' : '50px 78px 50px 50px'}}
    >
      <S.Title>Tags</S.Title>
      {    
        props.files.length === 0 ?
          <S.EmptyContainer>
            Upload file to add tags
          </S.EmptyContainer> 
        : !dsConfig ?
          <S.LoadingContainer>
            Loading tags, please wait...
          </S.LoadingContainer>
        :
          <S.TagsContainer>
            <S.TagColumn>
              <ComboBox 
                id="design-type"
                placeholder="Design Type"
                title="Design Type"
                options={designTypes ? designTypes.sort() : []}
                required={true}
                tipLabel={!(props.files[props.currentIndex]?.tags?.designType) && fromEditTemplate ? "ERROR: This field is required" : ""}
                tipLabelColor={!(props.files[props.currentIndex]?.tags?.designType) && fromEditTemplate ? C.RED : '#8891a0'}
                disabled={false}
                position={"bottom"}
                chooseOption={handleSelectOption}
                value={props.files[props.currentIndex]?.tags?.designType ? props.files[props.currentIndex]?.tags?.designType : ""}
              />
              <ComboBox 
                id="platform"
                placeholder="Platform"
                title="Platform"
                options={platforms ? platforms.sort() : []}
                required={true}
                tipLabel={!(props.files[props.currentIndex]?.tags?.platform) && fromEditTemplate ? "ERROR: This field is required" : ""}
                tipLabelColor={!(props.files[props.currentIndex]?.tags?.platform) && fromEditTemplate ? C.RED : '#8891a0'}
                disabled={false}
                position={"bottom"}
                chooseOption={handleSelectOption}
                value={props.files[props.currentIndex]?.tags?.platform ? props.files[props.currentIndex]?.tags?.platform : ""}
              />
              <ComboBox 
                id="formats"
                placeholder="Formats"
                title="Formats"
                options={formats ? [...formats.sort()] : []}
                multiSelect={true}
                multiSelectPlaceholder="sizes"
                required={true}
                tipLabel={
                  (!(props.files[props.currentIndex]?.tags?.formats) || 
                  (props.files[props.currentIndex]?.tags?.formats && props.files[props.currentIndex].tags.formats.length === 0)) 
                  && fromEditTemplate ? "ERROR: This field is required" : ""
                }
                tipLabelColor={
                  (!(props.files[props.currentIndex]?.tags?.formats) || 
                  (props.files[props.currentIndex]?.tags?.formats && props.files[props.currentIndex].tags.formats.length === 0)) 
                  && fromEditTemplate ? C.RED : '#8891a0'
                }
                disabled={false}
                position={!fromEditTemplate ? "bottom" : "top"}
                chooseOption={handleSelectOption}
                values={formatsToString("full-format")}
              />
              {  
                props.files[props.currentIndex]?.tags?.formats && props.files[props.currentIndex]?.tags?.formats.length > 1 &&
                <S.ChipsContainer>
                  <Chips 
                    items={formatsToString("name-format")}
                    handleRemove={handleRemoveFormat}
                  />
                </S.ChipsContainer>
              }
              <ComboBox 
                id="oem"
                placeholder="OEM"
                title="OEM"
                options={dsConfig.brands.map((item: IBrandDefinition)=>{return item.name;}).sort()}
                required={true}
                tipLabel={!(props.files[props.currentIndex]?.tags?.oem) && fromEditTemplate ? "ERROR: This field is required" : ""}
                tipLabelColor={!(props.files[props.currentIndex]?.tags?.oem) && fromEditTemplate ? C.RED : '#8891a0'}
                disabled={false}
                position={"top"}
                chooseOption={handleSelectOption}
                value={props.files[props.currentIndex]?.tags?.oem ? props.files[props.currentIndex]?.tags?.oem : ""}
              />
              { !fromEditTemplate && offerTypeAndHoliday()}
            </S.TagColumn>
            <S.VerticalDivider />
            <S.TagColumn>
              { fromEditTemplate && offerTypeAndHoliday()}
              <CustomTag 
                items={props.files[props.currentIndex]?.tags?.customTags ? props.files[props.currentIndex]?.tags?.customTags : []}
                addItems={handleAddCustomTag}
                removeItems={handleRemoveCustomTag}
                disabled={props.files[props.currentIndex]?.tags ? false : true}
                hideAuxText={fromEditTemplate}
              />
            </S.TagColumn>
          </S.TagsContainer>
      }
    </S.Root >
  );
}

export default Tags;